/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S5_Li4Inputs */

const en_guide_large_json_files_s5_li4 = /** @type {(inputs: Guide_Large_Json_Files_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>SQLite</strong>: Queryable database in a single file, great for structured data`)
};

const ko_guide_large_json_files_s5_li4 = /** @type {(inputs: Guide_Large_Json_Files_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>SQLite</strong>: 단일 파일의 쿼리 가능한 데이터베이스, 구조화된 데이터에 적합`)
};

const ja_guide_large_json_files_s5_li4 = /** @type {(inputs: Guide_Large_Json_Files_S5_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>SQLite</strong>: 単一ファイルのクエリ可能なデータベース、構造化データに最適`)
};

/**
* | output |
* | --- |
* | "<strong>SQLite</strong>: Queryable database in a single file, great for structured data" |
*
* @param {Guide_Large_Json_Files_S5_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s5_li4 = /** @type {((inputs?: Guide_Large_Json_Files_S5_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S5_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s5_li4(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s5_li4(inputs)
	return ja_guide_large_json_files_s5_li4(inputs)
});